"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Captcha = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _basis = require("basis");

var _templateObject;

var CaptchaImg = _styled.default.img(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 100%;\n"])));

var Captcha = function Captcha(props) {
  var theme = (0, _basis.useTheme)();
  var validation = props.validation,
      inputColor = props.inputColor;
  var _props$credentials = props.credentials,
      src = _props$credentials.src,
      width = _props$credentials.width,
      height = _props$credentials.height,
      alt = _props$credentials.alt,
      fieldID = _props$credentials.fieldID,
      optional = _props$credentials.optional,
      description = _props$credentials.description,
      name = _props$credentials.name;
  return /*#__PURE__*/_react.default.createElement("div", {
    key: fieldID
  }, /*#__PURE__*/_react.default.createElement("label", {
    style: theme.field.getCSS({
      targetElement: 'label'
    })
  }, name), /*#__PURE__*/_react.default.createElement(CaptchaImg, {
    "data-testid": "CaptchaImage",
    src: src,
    width: width,
    height: height,
    alt: alt || 'Captcha input image'
  }), /*#__PURE__*/_react.default.createElement(_basis.Input, {
    name: fieldID,
    testId: fieldID,
    hideLabel: true,
    optional: optional,
    helpText: description,
    validate: validation,
    label: "",
    color: inputColor
  }));
};

exports.Captcha = Captcha;